function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.2543 0.822327L23 5.56801L10.068 18.5L23 31.432L18.2543 36.1777L0.57666 18.5L18.2543 0.822327Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 37,
    viewBox: "0 0 23 37",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAyMyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguMjU0MyAwLjgyMjMyN0wyMyA1LjU2ODAxTDEwLjA2OCAxOC41TDIzIDMxLjQzMkwxOC4yNTQzIDM2LjE3NzdMMC41NzY2NiAxOC41TDE4LjI1NDMgMC44MjIzMjdaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9zdmc+DQo=";
export { SvgComponent as ReactComponent };